export function sortingFunctionForDate(a, b) {
  const dateA = new Date(a);
  const dateB = new Date(b);
  return dateA.getTime() - dateB.getTime();
}

export const sortingFunctionForIsSubmitted=(x, y) => {
    return (x.isSubmitted === y.isSubmitted) ? 0 : (x.isSubmitted ? -1 : 1)
};
